import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // Import the WhatsApp icon
import './whatsapp.css'; // Import the CSS file for styling

const WhatsAppButton = () => {
  const phoneNumber = '+94775147957'; 
  const message = 'Hello, I need assistance with...'; // Predefined message
  const encodedMessage = encodeURIComponent(message);

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
      <FaWhatsapp size={40} /> {/* Adjust icon size as needed */}
    </a>
  );
};

export default WhatsAppButton;

